module.exports = __webpack_public_path__ + "static/media/contact_email.e6956db2.svg";